import { Component, HostListener, input, output } from '@angular/core';
import { StoreFinderMapPointOfService } from '../../models/store-finder-list-item.models';
import { JsonPipe, NgClass, UpperCasePipe } from '@angular/common';
import { PhoneFilterPipe } from '@boels/helpers';
import { TranslocoPipe } from '@jsverse/transloco';
import { CmsRouterLinkDirective } from '@boels/shared-state';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faExternalLinkSquareAlt } from '@fortawesome/free-solid-svg-icons';
import { ButtonComponent } from '../../../../button/button.component';

@Component({
  selector: 'boels-store-finder-list-item',
  templateUrl: './store-finder-list-item.component.html',
  styleUrls: ['./store-finder-list-item.component.scss'],
  imports: [
    NgClass,
    PhoneFilterPipe,
    TranslocoPipe,
    CmsRouterLinkDirective,
    FaIconComponent,
    JsonPipe,
    UpperCasePipe,
    ButtonComponent,
  ],
})
export class StoreFinderListItemComponent {
  store = input.required<StoreFinderMapPointOfService>();
  isRegion = input<boolean>();
  isActive = input<boolean>();
  listNumber = input<number>();
  selectedStore = output<StoreFinderMapPointOfService>();

  @HostListener('click') onSelectStore() {
    this.selectedStore.emit(this.store());
  }

  protected readonly faExternalLinkAlt = faExternalLinkSquareAlt;
}
